import React from 'react'
import FormatClearIcon from '@mui/icons-material/FormatClear'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { useSelector, useDispatch } from 'react-redux'
import { ProfileAccountTypeRadios } from './Form/radios'
import { actions } from './reducer'
import { getIsAchDebit, getProfileForm } from './selectors'
import { createProfile } from './commands/profile/create'
import { ActionsDivComponent } from '../Register/Actions'
import { actions as registerActions } from '../Register/reducer'
import { getIsFormValid, getIsFormValidAchDebit } from './utils'
import { getApiConfig } from '../../utils/getApiConfig'
import { useUpdateFirebase } from './hooks/useUpdateFirebase'
import { getCustomerProfileId, getUserInfo } from '../App/selectors'
import { ProfileFormComponent } from './Form'
import { useCallbacks } from './hooks/useCallbacks'
import { PaperComponent } from './styled'
import { Stack } from '@mui/material'

export const CreateProfileComponent: React.FC = () => {
  const dispatch = useDispatch()

  const isAchDebit = useSelector(getIsAchDebit)
  const customerProfileId = useSelector(getCustomerProfileId)
  const profileForm = useSelector(getProfileForm)
  const userInfo = useSelector(getUserInfo)
  const isFormValid = isAchDebit
    ? getIsFormValidAchDebit(profileForm)
    : getIsFormValid(profileForm)

  useUpdateFirebase({ isFormValid })

  const { onBlured, blured, onReset, onChange, onIsAchDebit } = useCallbacks()

  React.useEffect(() => {
    if (userInfo?.email) {
      dispatch(actions.onProfileForm({ ...profileForm, email: userInfo.email }))
    }
  }, [dispatch, userInfo])

  React.useEffect(() => {
    if (customerProfileId) {
      onReset()
      dispatch(registerActions.onActiveStep(2))
    }
  }, [dispatch, customerProfileId, onReset])

  const onSubmit = React.useCallback(async () => {
    const config = await getApiConfig({ body: profileForm })
    if (config != null) createProfile(config)
  }, [createProfile, profileForm])

  return (
    <PaperComponent variant="outlined">
      <Stack display="flex" flexDirection="column" gap={1}>
        <ProfileAccountTypeRadios
          isAchDebit={isAchDebit}
          onIsAchDebit={onIsAchDebit}
        />
        <ProfileFormComponent
          profileForm={profileForm}
          blured={blured}
          onChange={onChange}
          onBlured={onBlured}
          isAchDebit={isAchDebit}
          isProfileCreate
        />
      </Stack>
      <br />
      <ActionsDivComponent
        onActionLeft={onReset}
        leftIcon={<FormatClearIcon />}
        textLeft="Reset"
        colorLeft="error"
        leftVariant="outlined"
        onActionRight={onSubmit}
        rightIcon={<NavigateNextIcon />}
        textRight="Submit"
        colorRight="primary"
        rightVariant="contained"
        disabledRight={!isFormValid}
      />
    </PaperComponent>
  )
}
